import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateText,
	validateEmail,
	validatePhoneNumber,
	validateUsername,
} from '../../../util/validation/commonValidation';
import type { FullOperatorDto } from '../types/OperatorDto';

export function useAddStaffGeneralForm(defaultOperator: FullOperatorDto) {
	const [inputs, setInputs] = useState<FullOperatorDto>(defaultOperator);

	const form = useForm<FullOperatorDto>({
		mode: 'uncontrolled',
		initialValues: defaultOperator,
		validate: {
			username: (value) => validateUsername(value),
			cardNo: (value) => validateText(value, false, 'Card number', 30),
			firstName: (value) => validateText(value, false, 'First name'),
			surname: (value) => validateText(value, false, 'Surname'),
			jobTitle: (value) => validateText(value, false, 'Job title'),
			phone: (value) => validatePhoneNumber(value, false),
			email: (value) => validateEmail(value, false),
			branchId: (value) => {
				if (!value) {
					return 'Please select a branch';
				}
			},
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
